import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ShieldCheck, ShieldX, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const money = (v) => `${Math.round(v || 0).toLocaleString("fr-FR")} FCFA`;

function Result({ r }) {
  if (!r.found) return (
    <div className="rounded-2xl border-2 border-rose-300 bg-rose-50 p-5 text-center" data-testid="verify-op-notfound">
      <ShieldX className="h-12 w-12 text-rose-600 mx-auto" /><p className="font-head text-lg font-bold mt-2">Reçu inconnu</p>
      <p className="text-sm text-slate-600">Aucune opération ne correspond à ce code. Ce reçu n'est pas authentique ou l'opération a été supprimée.</p>
    </div>
  );
  return (
    <div className="rounded-2xl border-2 border-emerald-400 bg-emerald-50 p-5" data-testid="verify-op-result">
      <div className="text-center">
        <ShieldCheck className="h-12 w-12 text-emerald-600 mx-auto" />
        <p className="font-head text-lg font-bold mt-2">Reçu authentique</p>
        <p className="text-xs text-slate-600">Cette opération est bien enregistrée dans la trésorerie de {r.company}.</p>
      </div>
      <dl className="mt-4 grid grid-cols-[auto_1fr] gap-x-3 gap-y-1.5 text-sm bg-white rounded-xl p-3">
        {[["Référence", r.numero, "reference"], ["Date", r.date, "date"], ["Type", r.type, "type"], ["Montant", money(r.montant), "montant"], ["Entreprise", r.company, "entreprise"]].map(([k, v, id]) => (
          <Fragment key={k}><dt className="text-slate-500">{k}</dt><dd className="font-medium break-words" data-testid={`verify-op-${id}`}>{v || "—"}</dd></Fragment>
        ))}
      </dl>
    </div>
  );
}

export default function VerifyOperation() {
  const { code } = useParams();
  const [r, setR] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    axios.get(`${API}/public/verify-operation/${encodeURIComponent(code)}`).then((x) => setR(x.data)).catch((e) => setErr(e.response?.data?.detail || "Vérification impossible"));
  }, [code]);
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10" data-testid="verify-op-page">
      <div className="max-w-lg mx-auto">
        <p className="text-[11px] font-mono uppercase tracking-widest text-brand-700 text-center">OMNIBAT ONE</p>
        <h1 className="font-head text-2xl sm:text-3xl font-bold text-center mb-6">Vérification de reçu de caisse</h1>
        {!r && !err && <p className="text-center text-sm"><Loader2 className="inline h-4 w-4 animate-spin mr-1" />Vérification…</p>}
        {err && <p className="text-center text-sm text-rose-600" data-testid="verify-op-error">{err}</p>}
        {r && <Result r={r} />}
        <p className="text-[11px] text-slate-400 text-center mt-6">Le motif détaillé de l'opération n'est jamais affiché sur cette page.</p>
      </div>
    </div>
  );
}
